import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((o) => !o);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = document.querySelector('nav')?.offsetHeight || 80;
      const headerOffset = navHeight + 12;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    } else {
      window.location.href = `/#${sectionId}`;
    }
    if (mobileMenuOpen) setMobileMenuOpen(false);
  };

  // Liens de navigation par audience
  const links = [
    { label: 'Particuliers', href: '/quick-delivery' },
    { label: 'Marchands', href: '/marchands' },
    { label: 'Devenir livreur', href: '/become-partner' },
    { label: 'Tarifs', href: '/get-quote' },
    { label: 'Suivre un colis', href: '/tracking' },
    { label: 'Mes expéditions', href: '/mes-expeditions' },
  ];

  const renderLink = (l, extraClass = 'nav-link') =>
    l.href ? (
      <a key={l.label} href={l.href} className={extraClass}>{l.label}</a>
    ) : (
      <button key={l.label} onClick={() => scrollToSection(l.section)} className={extraClass}>{l.label}</button>
    );

  return (
    <nav className="bg-white backdrop-blur-md py-5 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-screen-2xl w-full mx-auto px-5 md:px-16 flex justify-between items-center">
        <div className="flex items-center space-x-8">
          <a href="/" className="text-3xl font-bold">
            <span style={{ color: '#113039', fontFamily: 'Myriad Pro Bold, sans-serif' }}>Oui</span>
            <span style={{ fontFamily: 'Myriad Pro Bold, sans-serif' }} className="text-primary-custom">Goo</span>
          </a>
          <div className="hidden lg:flex space-x-8">
            {links.map((l) => renderLink(l))}
          </div>
        </div>

        <div className="hidden lg:flex items-center space-x-4">
          <a href="https://business.ouigoo.co" rel="noopener noreferrer" className="text-gray-800 hover:text-gray-500 font-semibold px-4 py-2 transition-all">
            Connexion
          </a>
          <a href="/quick-delivery" className="bg-primary-custom text-white font-semibold px-5 py-2 rounded-lg hover:bg-primary-custom-dark transition-all">
            Expédier un colis
          </a>
        </div>

        <button className="lg:hidden focus:outline-none" onClick={toggleMobileMenu} aria-label="Menu">
          {mobileMenuOpen ? <FaTimes className="text-gray-800 text-xl" /> : <FaBars className="text-gray-800 text-xl" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden ${mobileMenuOpen ? 'block' : 'hidden'} bg-white/95 backdrop-blur-md w-full border-t border-gray-200`}>
        <div className="container mx-auto py-4 flex flex-col space-y-4">
          {links.map((l) => renderLink(l, 'nav-link text-center block'))}
          <a href="https://business.ouigoo.co" rel="noopener noreferrer" className="border-2 border-gray-800 text-gray-800 font-semibold px-4 py-2 rounded-lg hover:bg-gray-800 hover:text-white text-center transition-all">
            Connexion
          </a>
          <a href="/quick-delivery" className="bg-primary-custom text-white font-semibold px-4 py-2 rounded-lg hover:bg-primary-custom-dark text-center transition-all">
            Expédier un colis
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
